import styles from '../../cleaning/balloon/Balloon.module.css';
import {Col, Row} from "react-bootstrap";
import axios from "axios";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock} from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import {useSelector} from "react-redux";
import {selectDrivesInRoutes} from "../route/routeSlice";
import _ from "lodash";
import {CRM_BASE_URL} from "../../../app/crm";

const DriveBalloon = ({drive}) => {
    const drivesInRoutes = useSelector(selectDrivesInRoutes);
    const routeDrive = _.find(drivesInRoutes, (item) => item.drive.id === drive.id)?.drive;
    const displayDrive = routeDrive || drive;

    return (
        <div className={styles.BalloonBody}>
            <Row>
                <Col md={12}>
                    <span className={styles.OrderNumber}>
                        <a target="_blank"
                           rel="noreferrer"
                           href={CRM_BASE_URL + '/onsite-drycleaning/update/' + drive.order.id}>
                            {drive.orderNumber}
                        </a>
                    </span>
                </Col>
                <Col md={12}>
                    <span className={classNames({[styles.Status]: true, [displayDrive.statusLabel]: true})}>
                        {displayDrive.statusAtString}
                    </span>
                </Col>
                <Col md={12}>
                    <span className={styles.Time}>
                        <FontAwesomeIcon icon={faClock}/> {displayDrive.time}
                    </span>
                </Col>
                {displayDrive.onsiteDrycleanerName ? <Col md={12}>
                    <span className={styles.Cleaner}>
                        Мастер — {displayDrive.onsiteDrycleanerName}
                    </span>
                </Col> : null}
            </Row>
        </div>
    );
};

export default DriveBalloon;
